import { Store } from '@ngrx/store';
import { AppState } from 'src/app/app.reducer';
import { EagerMultiSelectDataSource } from '../../extension/multi-select/eager-multi-select-data-source';
import { ExtensionGroupOption } from '../models/extension-group-option';
import { extensionGroupOptionActions } from '../state/extension-group-option.actions';
import { extensionGroupOptionSelectors } from '../state/extension-group-option.reducer';

export class ExtensionGroupMultiSelectDataSource extends EagerMultiSelectDataSource<ExtensionGroupOption> {
   constructor(store: Store<AppState>, filterOverrides: string[]) {
      super(store, extensionGroupOptionActions, extensionGroupOptionSelectors);
      this.filterOverrides = filterOverrides;
   }

   compareWith(a: ExtensionGroupOption, b: ExtensionGroupOption): boolean {
      return a.extensionGroupId === b.extensionGroupId;
   }
}
